import { useGetCronValidation } from "api/api-hooks/validator-hooks";
import { useState } from "react";
import useDebounce from "./useDebounce";

// eslint-disable-next-line import/prefer-default-export
export const useCronExpression = (expression: string) => {
  const [cronExp, setCronExp] = useState(expression);

  const debouncedSetCronExp = useDebounce(cronExp, { delay: 500 });

  const { data, isLoading } = useGetCronValidation(debouncedSetCronExp, {
    enabled: debouncedSetCronExp?.trim().length > 0,
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    cronExp,
    setCronExp,
    summary: data?.summary,
    isValid: data?.valid ?? true,
    isLoading,
  };
};
